// extracted by mini-css-extract-plugin
export default {"search":"styles_search__MnpiG"};